import "./PageContent.css";

function PageContent({ title, children }) {
  return (
    <div className="content flex-container-column small-content p-5 content-final">
      <div className="m-auto">
        <h2>{title}</h2>
        {children}
      </div>
    </div>
  );
}

export default PageContent;
